var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval Copy",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9331 27.586C17.9331 26.0793 19.0927 24.8665 20.5331 24.8665C21.9735 24.8665 23.1331 26.0793 23.1331 27.586V34.2801C23.1331 35.7867 21.9735 36.9997 20.5331 36.9997C19.0927 36.9997 17.9331 35.7867 17.9331 34.2801V27.586Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5863 30.0664C26.0797 30.0664 24.8667 28.9068 24.8667 27.4664C24.8667 26.026 26.0796 24.8665 27.5863 24.8665H34.2805C35.7872 24.8665 37.0001 26.026 37.0001 27.4664C37.0001 28.9068 35.7872 30.0664 34.2805 30.0664H27.5863Z",
    fill: "#ECB22D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8667 13.7196C24.8667 12.2129 26.0263 11 27.4667 11C28.9071 11 30.0667 12.2129 30.0667 13.7196V20.4137C30.0667 21.9204 28.9071 23.1333 27.4667 23.1333C26.0263 23.1333 24.8667 21.9204 24.8667 20.4137V13.7196Z",
    fill: "#2FB67C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7196 23.1332C12.2129 23.1332 11 21.9736 11 20.5332C11 19.0928 12.2129 17.9332 13.7196 17.9332H20.4137C21.9204 17.9332 23.1333 19.0928 23.1333 20.5332C23.1333 21.9736 21.9204 23.1332 20.4137 23.1332H13.7196Z",
    fill: "#36C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8667 34.3997C24.8667 35.8401 26.0263 36.9996 27.4667 36.9996C28.9071 36.9996 30.0667 35.8401 30.0667 34.3997C30.0667 32.9593 28.9071 31.7997 27.4667 31.7997H24.8667V34.3997Z",
    fill: "#ECB22D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3998 23.1332H31.7998V20.5332C31.7998 19.0928 32.9594 17.9332 34.3998 17.9332C35.8402 17.9332 36.9998 19.0928 36.9998 20.5332C36.9998 21.9736 35.8402 23.1332 34.3998 23.1332Z",
    fill: "#2FB67C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6 24.8665H16.2V27.4664C16.2 28.9068 15.0404 30.0664 13.6 30.0664C12.1596 30.0664 11 28.9068 11 27.4664C11 26.026 12.1596 24.8665 13.6 24.8665Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1331 13.6V16.2H20.5331C19.0927 16.2 17.9331 15.0404 17.9331 13.6C17.9331 12.1596 19.0927 11 20.5331 11C21.9735 11 23.1331 12.1596 23.1331 13.6Z",
    fill: "#36C5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.8ac966c5aeeec9f3a70d31ce469950de.svg";
export { ForwardRef as ReactComponent };